//export const API_URL = "https://rscoreapi.azurewebsites.net/api/"

export const API_URL = "https://testrsapi.realtyspacehub.com/api/"